import React from 'react';
import { Download, FileArchive } from 'lucide-react';
import { motion } from 'framer-motion';
import { Sidebar } from '../components/Sidebar';
import { TopBar } from '../components/TopBar';
import { downloads } from '../data/mockData';

export default function Downloads() {
  const handleDownload = (id, title) => {
    console.log('Downloading:', id, title);
  };

  const getIconComponent = (iconName) => {
    switch (iconName) {
      case 'FileArchive':
        return FileArchive;
      default:
        return Download;
    }
  };

  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <Sidebar />
      
      <div className="md:ml-64">
        <TopBar />
        
        <main className="p-6 md:p-12 max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="space-y-8"
          >
            <div>
              <h1
                className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-2"
                style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
                data-testid="downloads-title"
              >
                Downloads
              </h1>
              <p className="text-lg text-muted-foreground">
                Get all your generated application files
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="downloads-grid">
              {downloads.map((item, index) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.05 }}
                  className="flex flex-col p-6 rounded-xl border border-white/5 bg-white/5 hover:bg-white/10 hover:border-primary/30 transition-all group"
                  data-testid={`download-card-${item.id}`}
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                      <FileArchive className="w-6 h-6 text-primary" />
                    </div>
                    <div className="px-2.5 py-1 rounded-md bg-white/5 border border-white/10 text-xs font-medium text-muted-foreground">
                      {item.format}
                    </div>
                  </div>

                  <div className="flex-1 space-y-2 mb-4">
                    <h3 className="text-lg font-semibold text-white" data-testid={`download-title-${item.id}`}>
                      {item.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">{item.description}</p>
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-white/5">
                    <span className="text-sm text-muted-foreground">{item.size}</span>
                    <motion.button
                      onClick={() => handleDownload(item.id, item.title)}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      data-testid={`download-button-${item.id}`}
                      className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 hover:bg-primary/20 text-primary border border-primary/20 text-sm font-medium transition-colors"
                    >
                      <Download className="w-4 h-4" />
                      Download
                    </motion.button>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </main>
      </div>
    </div>
  );
}
